import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { Div } from 'elements/layout/Div'
import { Span } from 'elements/layout/Span'
import { Icon } from 'elements/media/Icon'

import { ICON } from 'config/icons'

import { TPrayerMeeting } from 'modules/meeting/types'

import { TPrayerEvent } from '../../types'

type TCardFooterProps = {
  prayerEvent: TPrayerEvent
  prayerMeetings: TPrayerMeeting[]
  isSingleDayEvent: boolean
}

export const PrayerEventInfoCardFooter: TFC<TCardFooterProps> = ({ prayerEvent, prayerMeetings, isSingleDayEvent }) => {
  const { t } = useTranslation()
  const eventStartDate = dayjs(prayerEvent.startAt)
  const eventEndDate = dayjs(prayerEvent.endAt)

  return (
    <Div display="flex" w="100%" align="middleBetween" color="black50">
      <Div align="middle">
        <Icon name={ICON.CALENDAR} m="0 5px 0 0" />
        <Span>
          {`${eventStartDate.format('D')} - ${isSingleDayEvent ? '' : eventEndDate.format('D')} ${dayjs(
            eventStartDate,
          ).format('MMM')}`}
        </Span>
      </Div>

      <Div align="middle">
        <Icon name={ICON.HOZANA} m="0 5px 0 0" />
        <Span>{`${prayerMeetings.length} ${t('event:event.map.card.meetings')}`}</Span>
      </Div>

      <Div align="middle">
        <Icon name={ICON.CONTACTS} m="0 5px 0 0" />
        <Span>{`${prayerMeetings.reduce((acc, curr) => acc + curr.numberSubscribers, 0)} ${t(
          'event:event.map.card.subscriptions',
        )}`}</Span>
      </Div>
    </Div>
  )
}
